import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAccount } from "wagmi";
import Admin from "pages/Admin";
import Dashboard from "pages/Dashboard";
import Layout from "pages/Layout";
import Myprojects from "pages/Myprojects";
import Subscription from "pages/Subscription";
import Usage from "pages/Usage";
import SubscriptionPaymentSuccess from "pages/SubscriptionPaymentSuccess";
import TransactionAndStream from "pages/TransactionAndStream";
import SubscriptionPayment from "pages/SubscriptionPayment";
// import Transaction from "pages/Transaction";
import {
  getMySubscription,
  getNetwork,
  getSignatureMessage,
  getSubscriptionOptions,
  getUserDetails,
  handleLogin,
  resetAllState,
  setAccountData,
  setShowSubscriptionPopup,
  setGlobalChainID,
  setShowSubscriptionExpirePopup,
  setRemainingDays,
} from "store/globalSlice";
import { getDataFromLocalStorage } from "utils/helpers";
import { SubscriptionPopup, Feedback } from "components";
import moment from "moment";

const AppRoute = () => {
  const dispatch = useDispatch();
  const reduxData = useSelector((state) => state.global);
  const { subscriptionEndDate, remainingDays } = reduxData || {};
  const account = useAccount();
  const [count, setCount] = useState(1);
  const { address } = account;

  const initAPI = async () => {
    getChainID();
    await dispatch(getMySubscription());
    await dispatch(getUserDetails());
    await dispatch(getNetwork());
    await dispatch(getSubscriptionOptions());
  };

  const handleRelogin = async (newAddress) => {
    const ethereum = window.ethereum;
    const response = await dispatch(getSignatureMessage(newAddress));
    if (response?.status === 403) {
      localStorage.isAlphaMode = 1;
      handleLogout();
      return;
    }
    const customMessage = response?.data?.message || "";
    try {
      const signature = await ethereum.request({
        method: "personal_sign",
        params: [customMessage, address],
      });
      const loginResponse = await dispatch(
        handleLogin({
          address: address,
          signature: signature,
          message: customMessage,
        })
      );
      if (loginResponse?.status === 201) {
        localStorage.removeItem("initShowSubscriptionPopup");
        setCount(count + 1);
        initAPI();
      }
    } catch (error) {
      // setIsLoading(false);
      console.log(error);
    }
  };

  const handleLogout = () => {
    dispatch(setAccountData(null));
    dispatch(resetAllState(null));
    dispatch(setShowSubscriptionPopup(false));
    localStorage.removeItem("accountData");
    localStorage.removeItem("initShowSubscriptionPopup");
    localStorage.removeItem("theme");
    localStorage.removeItem("subscriptionEndDate");
    localStorage.removeItem("subscriptionEndMinute");
  };

  const getChainID = () => {
    if (window.ethereum) {
      window.ethereum
        .request({ method: "eth_chainId" })
        .then(async (chainId) => {
          let pChainID = parseInt(chainId, 16);
          dispatch(setGlobalChainID(pChainID));
        });
    }
  };

  useEffect(() => {
    initAPI();
    if (window.ethereum) {
      window.ethereum.on("chainChanged", () => {
        getChainID();
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (address) {
      if (address !== getDataFromLocalStorage("address")) {
        dispatch(setShowSubscriptionPopup(false));
        handleRelogin(address);
      }
    } else {
      handleLogout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address]);

  const checkSubscriptionEndDate = () => {
    if (!subscriptionEndDate) {
      return;
    }
    const subEndDate = moment(subscriptionEndDate, "YYYY-MM-DDTHH:mm:ss.SSSZ");
    const currentDate = moment();
    const remainingDay = subEndDate.diff(currentDate, "days");
    const remainingMinutes = subEndDate.diff(currentDate, "minutes");
    // let remainingDay = 7
    dispatch(setRemainingDays(remainingDay));
    localStorage.setItem("subscriptionEndDate", remainingDay);
    localStorage.setItem("subscriptionEndMinute", remainingMinutes);
    if (remainingDay <= 7) {
      dispatch(setShowSubscriptionExpirePopup(true));
    } else {
      dispatch(setShowSubscriptionExpirePopup(false));
    }
  };
  useEffect(() => {
    checkSubscriptionEndDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptionEndDate]);

  useEffect(() => {
    if (remainingDays <= 7) {
      dispatch(setShowSubscriptionExpirePopup(true));
    } else {
      dispatch(setShowSubscriptionExpirePopup(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remainingDays]);

  return useMemo(() => {
    return (
      <>
        <SubscriptionPopup />
        <Feedback />
        <Routes>
          <Route
            path="/dashboard"
            element={
              <Layout handleLogout={handleLogout}>
                <Dashboard />
              </Layout>
            }
          />
          <Route
            path="/my-projects"
            element={
              <Layout handleLogout={handleLogout}>
                <Myprojects />
              </Layout>
            }
          />
          <Route
            path="/subscription"
            element={
              <Layout handleLogout={handleLogout}>
                <Subscription />
              </Layout>
            }
          />
          <Route
            path="/subscription-payment/:sub_tier_id"
            element={<SubscriptionPayment />}
          />
          <Route
            path="/subscription-payment-success"
            element={<SubscriptionPaymentSuccess />}
          />
          <Route
            path="/admin"
            element={
              <Layout handleLogout={handleLogout}>
                <Admin handleLogout={handleLogout} />
              </Layout>
            }
          />
          <Route
            path="/usage"
            element={
              <Layout handleLogout={handleLogout}>
                <Usage />
              </Layout>
            }
          />
          <Route
            path="/transaction"
            element={
              <Layout handleLogout={handleLogout}>
                <TransactionAndStream />
              </Layout>
            }
          />
          <Route path="*" element={<Navigate replace to="/dashboard" />} />
        </Routes>
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);
};

export default AppRoute;
